import React from "react";
import moment from "moment";
import { AckFeedback } from "../../AckFeedback";
import { ReplySourcesSended } from "../../ReplySourcesSended";
import * as S from "./../styles";
import MessageBody from "./MessageBody";
import MessageHeader from "./MessageHeader";
import FailSendMessage from "./FailSendMessage";
import { BiTime } from "react-icons/bi";

function showMessageError(message) {
  const fromUserAndFromWhatsapp =
    message.from === "user" && !!message?.ack?.whatsapp;

  const errorWhatsapp = message?.ack?.whatsapp?.status == "error";

  const createdAt = moment(message.created_at);
  const waiterThan5Minutes = moment().diff(createdAt, "minutes") >= 5;
  const whatsappStatusNull = !message?.ack?.whatsapp?.status;

  return (
    fromUserAndFromWhatsapp &&
    (errorWhatsapp || (waiterThan5Minutes && whatsappStatusNull))
  );
}

function MessageItem({
  message,
  setShowImage,
  setAnswerMessage,
  customer,
  focusMessage,
}) {
  return (
    <S.Item
      key={message.id}
      className={`${message.from} ${
        message?.ack?.whatsapp?.status === "not_found" && "not_found"
      }`}
      id={`message-${message.id}`}
    >
      <S.ContainerMessages sides={message?.from}>
        <S.Message
          id={`message-body-${message.id}`}
          size={message?.attachment_content_type}
        >
          {["user", "customer"].includes(message.from) && (
            <MessageHeader
              message={message}
              setAnswerMessage={setAnswerMessage}
            />
          )}

          <MessageBody
            focusMessage={focusMessage}
            message={message}
            setShowImage={setShowImage}
            customer={customer}
          />

          <S.Footer>
            <ReplySourcesSended ack={message.ack || {}} />

            <S.MessageDate>
              {moment(message.created_at).format("DD/MM/YY HH:mm")}
            </S.MessageDate>

            {message?.from_api && <S.Clock />}

            {message.from === "user" &&
              (message?.ack?.email || message?.ack?.whatsapp) && (
                <AckFeedback
                  ack={message.ack || {}}
                  messageType={message?.attachment_content_type}
                />
              )}
          </S.Footer>
        </S.Message>
        {showMessageError(message) && (
          <FailSendMessage customer={customer} message={message} />
        )}
      </S.ContainerMessages>
    </S.Item>
  );
}

export default React.memo(MessageItem);
